module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hu40W"))).then(() => parcelRequire('ljYL6'));